<template>
	<button
		type="button"
		aria-label="Open Menu"
		@click="openAuthMenu"
		:class="['w-6 h-6 md:w-5 md:h-5 flex items-center justify-center', btnClass]"
	>
		<svg-vue icon="user-md" class="w-6 h-6 md:w-5 md:h-5 overflow-visible" />
	</button>
	<TransitionRoot unmount :show="authMenuOpen">
		<TransitionChild
			as="template"
			enter="transition-opacity ease-linear duration-300"
			enter-from="opacity-0"
			enter-to="opacity-100"
			leave="transition-opacity ease-linear duration-300"
			leave-from="opacity-100"
			leave-to="opacity-0"
		>
			<div class="bg-black/50 fixed inset-0 z-20" @click="handleClickoutside"></div>
		</TransitionChild>
		<TransitionChild
			as="template"
			enter="transition ease-in-out duration-300 transform"
			enter-from="translate-x-full"
			enter-to="translate-x-0"
			leave="transition ease-in-out duration-300 transform"
			leave-from="translate-x-0"
			leave-to="translate-x-full"
		>
			<aside class="bg-white fixed top-0 right-0 w-80 h-full z-20">
				<div class="w-full h-full relative overflow-y-scroll no-scrollbar">
					<button
						v-if="showClose"
						type="button"
						aria-label="Close Shopping Bag"
						@click="closeAuthMenu"
						class="absolute md:left-4 md:top-3 top-2 right-4"
					>
						<svg-vue icon="close-md" class="w-3 h-3"></svg-vue>
					</button>
					<slot name="routes" />
				</div>
			</aside>
		</TransitionChild>
	</TransitionRoot>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { TransitionRoot, TransitionChild } from '@headlessui/vue'
import { storeToRefs } from 'pinia'

import { useAppStore } from '@stores'

const props = defineProps({
	btnClass: {
		type: String,
		default: '',
	},
	showClose: {
		type: Boolean,
		default: false,
	},
})

const appStore = useAppStore()
const { authMenuOpen } = storeToRefs(appStore)
const { openAuthMenu, closeAuthMenu } = appStore

onMounted(() => document.addEventListener('keydown', handleKeydown))
onUnmounted(() => document.removeEventListener('keydown', handleKeydown))

const handleKeydown = (e) => {
	if (e.key === 'Escape' && authMenuOpen.value) {
		closeAuthMenu()
	}
}
const handleClickoutside = () => {
	if (authMenuOpen.value) {
		closeAuthMenu()
	}
}
</script>
